import { Component, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminAccount, AdminGroup } from '../../../../../Models/avyna/agent-device.model';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import { AvTableColumn, AvTableRow } from '../../../../Shared/Interfaces/av-table-card.interface';
import { ShowDeviceFacade } from '../../../../../Facades/Intune/show-device.facade';

@Component({
  selector: 'app-local-admin',
  standalone: true,
  imports: [AvContentContainerComponent, AvTableCard],
  templateUrl: './local-admin.component.html',
  styleUrls: ['./local-admin.component.scss'],
})
export class LocalAdminComponent {
  private readonly _facade = inject(ShowDeviceFacade);
  private readonly translate = inject(TranslateService);

  readonly device = this._facade.device;

  readonly adminGroupColumns: AvTableColumn[] = [
    { key: 'sid', label: 'app.device.local_admin.columns.sid', sortable: true },
    { key: 'name', label: 'app.device.local_admin.columns.name', sortable: true },
    { key: 'description', label: 'app.device.local_admin.columns.description', sortable: true },
  ];

  readonly adminAccountColumns: AvTableColumn[] = [
    { key: 'sid', label: 'app.device.local_admin.columns.sid', sortable: true },
    { key: 'name', label: 'app.device.local_admin.columns.name', sortable: true },
    { key: 'accountType', label: 'app.device.local_admin.columns.account_type', sortable: true },
    { key: 'principalSource', label: 'app.device.local_admin.columns.principal_source', sortable: true },
  ];

  readonly adminGroupRows = computed<AvTableRow[]>(() => {
    const groups = this.device()?.agent?.local_admin_info?.admin_groups;
    if (!Array.isArray(groups)) return [];

    return groups.map((group: AdminGroup) => ({
      name: this.fallbackString(group?.name),
      sid: this.fallbackString(group?.sid),
      description: this.fallbackString(group?.description),
    }));
  });

  readonly adminAccountRows = computed<AvTableRow[]>(() => {
    const accounts = this.device()?.agent?.local_admin_info?.admin_accounts;
    if (!Array.isArray(accounts)) return [];

    return accounts.map((account: AdminAccount) => ({
      name: this.fallbackString(account?.name),
      sid: this.fallbackString(account?.sid),
      accountType: this.fallbackString(account?.account_type),
      principalSource: this.fallbackString(account?.principal_source),
    }));
  });

  private fallbackString(value?: string | null): string {
    if (value && value.trim().length > 0) return value;
    return this.translate.instant('shared.general.labels.na');
  }
}
